import UserIcon from './user-icon';

export default UserIcon;